import { animate, state, style, transition, trigger } from '@angular/animations';
import { CmsModulePositionComponent, CmsModulesService } from '@common/cms/frontend-shared';
import { ConfigService } from '@core/shared/config';
import { map } from 'rxjs';
import { NgClass, AsyncPipe } from '@angular/common';
import { FeedbackFormComponent } from './feedback-form.component';
import { UiHoverLabelButtonComponent } from '@common/ui/frontend-shared/button';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/config";
import * as i2 from "@common/cms/frontend-shared";
function FeedbackButtonComponent_Conditional_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "cms-module-position", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("position", ctx_r1.moduleId)("context", ctx_r1.moduleContext);
  }
}
function FeedbackButtonComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "h2");
    i0.ɵɵtext(3, "Kontakt & Feedback");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "feedback-form", 3);
    i0.ɵɵlistener("formSent", function FeedbackButtonComponent_Conditional_2_Template_feedback_form_formSent_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.afterSubmit());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(5, FeedbackButtonComponent_Conditional_2_Conditional_5_Template, 2, 2, "div", 4);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@fadeInOut", undefined)("ngClass", ctx_r1.popupDirection);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("removeTheming", true);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(6, 4, ctx_r1.hasModules$) ? 5 : -1);
  }
}
export let FeedbackButtonComponent = /*#__PURE__*/(() => {
  class FeedbackButtonComponent {
    constructor(config, cmsModules) {
      this.cmsModules = cmsModules;
      this.toggled = false;
      this.moduleId = "contact-popup-top";
      this.popupDirection = 'down';
      this.buttonClass = '';
      this.moduleContext = {
        contactEmail: config.get('contact.mail', null),
        contactPhone: config.get('contact.phone', null),
        businessHours: config.get('contact.businessHours', null)
      };
      this.hasModules$ = cmsModules.getModulesForPosition(this.moduleId).pipe(map(list => list && list.length > 0));
    }
    getClass() {
      let out = this.buttonClass;
      if (this.toggled) out += ' ui-button-contrast';
      return out;
    }
    toggle() {
      this.toggled = !this.toggled;
    }
    afterSubmit() {
      setTimeout(() => {
        this.toggled = false;
      }, 5000);
    }
    static {
      this.ɵfac = function FeedbackButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FeedbackButtonComponent)(i0.ɵɵdirectiveInject(i1.ConfigService), i0.ɵɵdirectiveInject(i2.CmsModulesService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: FeedbackButtonComponent,
        selectors: [["feedback-button"]],
        inputs: {
          popupDirection: "popupDirection",
          buttonClass: "buttonClass"
        },
        decls: 3,
        vars: 6,
        consts: [["uiHoverLabelButton", "", "iconSize", "lg", "rounded", "true", "raised", "true", "e2e-feedback-toggle-popup", "", 1, "btn-toggle", 3, "click", "icon", "stayOpen", "toggled", "label", "ngClass"], ["ui-theme", "inherit-page", 1, "popup", 3, "ngClass"], [1, "block", "form"], ["ui-theme", "inherit-page", "title", "Geben Sie uns Feedback", 3, "formSent", "removeTheming"], [1, "block", "ui-text-center", "module-box"], [3, "position", "context"]],
        template: function FeedbackButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "button", 0);
            i0.ɵɵlistener("click", function FeedbackButtonComponent_Template_button_click_1_listener() {
              return ctx.toggle();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(2, FeedbackButtonComponent_Conditional_2_Template, 7, 6, "div", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("icon", ctx.toggled ? "times" : "comments")("stayOpen", ctx.toggled)("toggled", ctx.toggled)("label", ctx.toggled ? "schlie\u00DFen" : "Kontakt")("ngClass", ctx.buttonClass);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.toggled ? 2 : -1);
          }
        },
        dependencies: [UiHoverLabelButtonComponent, NgClass, FeedbackFormComponent, CmsModulePositionComponent, AsyncPipe],
        styles: ["[_nghost-%COMP%] > div[_ngcontent-%COMP%]{position:relative}.popup[_ngcontent-%COMP%]{position:absolute;right:5px;box-shadow:var(--inputOverlayShadow);width:340px;z-index:1000;overflow:auto;background:var(--contentSoftColor)}.popup.down[_ngcontent-%COMP%]{top:60px}.popup.up[_ngcontent-%COMP%]{bottom:60px}.popup[_ngcontent-%COMP%]     .p-panel .p-panel-content{border:none}.popup[_ngcontent-%COMP%]   .block[_ngcontent-%COMP%]{padding:15px}.popup[_ngcontent-%COMP%]   .block.module-box[_ngcontent-%COMP%]{background-color:var(--accentColor);color:var(--accentTextColor)}.popup[_ngcontent-%COMP%]   .block.module-box[_ngcontent-%COMP%]     a{color:var(--primaryTextColor);text-decoration:underline}.editor[_ngcontent-%COMP%]{width:100%}@media (max-width: 400px){.popup[_ngcontent-%COMP%]{width:300px;right:5px}}"],
        data: {
          animation: [trigger('fadeInOut', [state('void', style({
            opacity: 0
          })), transition('void <=> *', animate(200))])]
        }
      });
    }
  }
  return FeedbackButtonComponent;
})();